import React from "react";
import { useAcceptTicketMutation, useGetPendingTicketsQuery, useRejectTicketMutation } from "../../../services/ticket.api.ts";
import { toast } from "react-toastify";
import './TicketAssignment.css'

const TicketAssignment = ({ ticketId }) => {
    const [acceptTicket] = useAcceptTicketMutation();
    const [rejectTicket] = useRejectTicketMutation();
    const { data: pendingTicketList } = useGetPendingTicketsQuery();
  
    const isTicketPending = () => {
      if (!pendingTicketList?.tickets || !ticketId) return false;
      return pendingTicketList.tickets.includes(Number(ticketId));
    };
  
    const handleAcceptTicket = async () => {
      try {
        await acceptTicket({ ticketId: Number(ticketId) }).unwrap();
        toast.success('Ticket accepted successfully');
      } catch (error) {
        console.error('Failed to accept ticket:', error);
        toast.error('Failed to accept ticket');
      }
    };
  
    const handleRejectTicket = async () => {
      try {
        await rejectTicket({ ticketId: Number(ticketId) }).unwrap();
        toast.success('Ticket rejected successfully');
      } catch (error) {
        console.error('Failed to reject ticket:', error);
        toast.error('Failed to reject ticket');
      }
    };
  
    return (
      <div className="assignment-card">
        <button>Assign Agent</button>
        <button
          onClick={handleAcceptTicket}
          disabled={!isTicketPending()}
          className="accept"
        >
          Accept Ticket
        </button>
        <button
          onClick={handleRejectTicket}
          disabled={!isTicketPending()}
          className="reject"
        >
          Reject Ticket
        </button>
      </div>
    );
  };

export default TicketAssignment